// confirmation-modal.component.ts
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ConfirmationModalData {
  title?: string;
  message?: string;
  placeholder?: string;
  required?: boolean;
  maxLength?: number;
  yesText?: string;
  noText?: string;
}

export interface ConfirmationModalResult {
  confirmed: boolean;
  description: string;
}

@Component({
  selector: 'app-confirmation-modal',
   templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.css'],
})
export class ConfirmationModalComponent {
  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<ConfirmationModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationModalData
  ) {
    this.form = this.fb.group({
      description: ['', this.buildValidators()]
    });
  }

  private buildValidators() {
    const validators = [];
    if (this.data.required) {
      validators.push(Validators.required);
    }
    if (this.data.maxLength) {
      validators.push(Validators.maxLength(this.data.maxLength));
    }
    return validators;
  }

  onConfirm(): void {
    if (this.isFormValid()) {
      const result: ConfirmationModalResult = {
        confirmed: true,
        description: this.form.get('description')?.value || ''
      };
      this.dialogRef.close(result);
    }
  }

  onCancel(): void {
    const result: ConfirmationModalResult = {
      confirmed: false,
      description: ''
    };
    this.dialogRef.close(result);
  }

  isFormValid(): boolean {
    return this.form.valid;
  }
}
